<template>
    <div class="zgxdq">
         <easyCruds ref="mainTable" :tableInfo="mainTable"
                @mainTableReload="mainTableReload"
                @beforeAddFunctionName="beforeAddFunctionName"
                @beforeEditFunctionName="beforeEditFunctionName"
                @addRow="addRow"
                @editRow="editRow"
                @deleteRows="deleteRows"
                @resrt="resrt">
                <template  slot="conditionExpressValueForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
                        <el-row :gutter="10" v-for="(option,index) in tjoptions" :key="index" style="margin-left:0">
                            <el-col :span="3">
                                <el-select v-model="option.op1.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in option.op1.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-select v-model="option.op2.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in option.op2.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-select v-model="option.op3.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in option.op3.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-input v-model="option.op4.value" placeholder="请输入内容"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <el-select v-model="option.op5.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in option.op5.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-select v-model="option.op6.value" placeholder="请选择">
                                    <el-option
                                    v-for="item in option.op6.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3" style="text-align:center">
                                <i class="el-icon-circle-plus-outline" style="font-size:24px" @click="tjadd(index,option)"></i>
                                <i class="el-icon-remove-outline" style="font-size:24px" @click="tjsub(index)"></i>
                            </el-col>
                        </el-row>
                </template>
            </easyCruds>
    </div>
</template>



<script>
    export default {
        data() {
            return {
                xn:null,
                mainTable: {
                    buttonSetting: {
                        resetFunctionName:'resrt',
                        allowAdd: true,
                        addButtonArray:[{
                            clickEvent: 'addRow',
                            type:'primary',
                            buttonName:'新增',
                            validate:true
                        }],
                        deleteFunctionName: 'deleteRows',
                        allowEdit: true,
                        editButtonArray:[{
                            clickEvent:'editRow',
                            type:'primary',
                            buttonName:'保存编辑',
                            validate: true
                        }],
                        beforeAddFunctionName:"beforeAddFunctionName",
                        beforeEditFunctionName: 'beforeEditFunctionName',

                        allowDelete: true,
                        allowView: false,
                    },
                    header: {
                        title: '资格限定器列表'
                    },
                    table: {
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: true,
                        index: true,
                        columns: [{
                            prop: 'limitName',
                            label: '限定器名称',
                            required: true,
                            isSearchCondition: true,
                            span: 12,
                            dicData: []
                        },
                        {
                            prop: 'xn',
                            label: '学年',
                            required: true, 
                            isSearchCondition: true,
                            type: 'select',
                            rows: 5,
                            span: 12,
                            dicData: []
                        },
                        {
                            prop: 'xq',
                            label: '学期',
                            required: true, 
                            isSearchCondition: true,
                            type: 'select',
                            span: 12,
                            // required: true,
                            dicData: [
                                {
                                    label:"第一学期",
                                    value:'1'
                                },
                                {
                                    label:"第二学期",
                                    value:"2"
                                }
                            ],
                            dataFilter:(value) =>{
                                if(value==="1"){
                                    return "第一学期"
                                }
                                if(value==="2"){
                                    return "第二学期"
                                }
                            }
                        }, 
                        {
                            prop: 'application',
                            label: '参评大类',
                            isSearchCondition: true,    
                            required: true,            
                            type: 'select',
                            span: 12,
                            dicData: [],
                            dataFilter:(value) =>{
                                let temp = this.mainTable.table.columns.filter(item => item.prop === 'application');
                                let data=temp[0].dicData.filter(e=>{
                                    return e.value==value
                                })
                                
                                if(data.length>0){
                                    return data[0].label
                                }
                            }
                        },
                        {
                            prop: 'enable',
                            label: '是否启用',
                            isSearchCondition: true,
                            required: true,
                            type: 'select',
                            span: 12,
                            dicData: [
                                {
                                    label:'启用',
                                    value:1
                                },
                                {
                                    label:'禁用',
                                    value:0
                                }
                            ]
                        },  
                        {
                            prop: 'conditionExpressValue',
                            label: '条件',
                            type: 'select',
                            span: 24,
                            dicData: [],
                            formslot: true
                        }, 
                        {
                            prop: 'creator',
                            label: '发布人',
                            type: 'select',
                            span: 12,
                            dicData: [],
                            view:[false,false,false]   //新增,查看,编辑
                        }],
                        operation: {
                            width: '220',
                        },
                        tableData: [],
                        paging: {
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }

                },
                input:'',
                options:[],
                tjoptions:[
                    {
                        op1:{
                            value:'',
                            options:[
                                {
                                    value: '(',
                                    label: '('
                                },
                                {
                                    value: '',
                                    label: ' '
                                }
                            ]
                        },
                        op2:{
                            value:'',
                            options:[]
                        },
                        op3:{
                            value:'',
                            options:[
                                {
                                    value:'=',
                                    label:'等于'
                                },
                                {
                                    value:'>',
                                    label:'大于'
                                },
                                {
                                    value:'>=',
                                    label:'大于等于'
                                },
                                {
                                    value:'<',
                                    label:'小于'
                                },
                                {
                                    value:'<=',
                                    label:'小于等于'
                                },
                                {
                                    value:'!=',
                                    label:'不等于'
                                },
                                {
                                    value:'IN',
                                    label:'在之内'
                                },
                                {
                                    value:'NOT IN',
                                    label:'不在'
                                }
                            ]
                        },
                        op4:{
                            value:''
                        },
                        op5:{
                            value:'',
                            options:[
                                {
                                    value:')',
                                    label:')'
                                },
                                {
                                    value:'',
                                    label:' '
                                }
                            ]
                        },
                        op6:{
                            value:'',
                            options:[
                                {
                                    value:'OR',
                                    label:'或者'
                                },
                                {
                                    value:'AND',
                                    label:'并且'
                                }
                            ]
                        }
                    }                    
                ]
            }
        },
        methods: {
            mainTableReload(params){
                params = params || {}
                this.mainTable.table.loading = true
                if (!params.pageSize) { params.pageSize = 10 }
                if (!params.pageNum) { params.pageNum = 1 }
                params.applicationType=params.application;
                delete params.application;
                this.$http.get('/limit/query', { params }).then(
                    res => {
                        // console.log(params)
                        this.mainTable.table.loading = false;
                        this.mainTable.table.tableData = res.data.records
                        this.mainTable.table.paging.total = res.data.total || res.data.records.length
                    }
                ).catch(
                    error => {
                    this.mainTable.table.loading = false;
                    this.$message.error(error.msg)
                    }
                )
            },
            // 新增之前
            beforeAddFunctionName: function(row, type, callback) {
                this.op2();
                Object.assign(this.tjoptions.map(e=>{
                    e.op1.value="";
                    e.op2.value="";
                    e.op3.value="";
                    e.op4.value="";
                    e.op5.value="";
                    e.op6.value="";
                    return e
                }))
                this.tjoptions=this.$options.data().tjoptions;
                // console.log(this.tjoptions);
                callback();
            },
            // 条件参数
            datalist(row){
                let datalist=[]
                this.tjoptions.forEach(e=>{
                    let op3=e.op3.options.filter(i=>i.value===e.op3.value);
                    let op3_1=e.op3.options.filter(i=>i.label===e.op3.value);
                    let op2=e.op2.options.filter(i=>i.value===e.op2.value);
                    let op2_1=e.op2.options.filter(i=>i.label===e.op2.value);
                    if(op3.length<=0){
                        if(op3_1.length>0){
                            op3=op3_1[0]
                        }else{
                            op3=""
                        }
                    }else{
                        op3=op3[0]
                    }

                    if(op2.length<=0){
                        if(op2_1.length>0){
                            op2=op2_1[0]
                        }else{
                            op2=""
                        }
                    }else{
                        op2=op2[0]
                    }

                    let conditionFlagValue=e.op6.options.filter(i=>i.value===e.op6.value);
                    if(conditionFlagValue.length>0){
                        conditionFlagValue=conditionFlagValue[0].label
                    }else{
                        conditionFlagValue=""
                    }
                    datalist.push({
                        conditionLeft:e.op1.value,
                        conditionClomn:op2&&op2.value,
                        conditionValue:op2&&op2.label,
                        conditionType:op3&&op3.value,
                        coditionTypeValue:op3&&op3.label,
                        conditionOperator:e.op4.value,
                        conditionRight:e.op5.value,
                        conditionFlag:e.op6.value,
                        conditionFlagValue:conditionFlagValue,
                        limitId:row.id
                    })
                })
                return datalist
            },
            // 新增
            addRow(row, done, errorDone){
                let datalist=this.datalist(row);
                this.$http.post("/limit/saveOrUpdate",
                    {
                        "limitSetVoList":datalist,
                        "limitName": row.limitName,
                        "xn": row.xn,
                        "application": row.application.toString(),
                        "enable": row.enable.toString(),
                        "conditionId": "string",
                        "creator": "wipadmin",
                        "limitId":row.id,
                        "xq": ((row.xq)*1).toString()
                    },{
                        params:{
                            type:"1"
                        }
                    }
                ).then(res=>{
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
                done();
            },
            resrt(){},

            // 编辑之前
            beforeEditFunctionName: function(row, type, callback) {

                this.$http.get("/limit/get",{
                    params:{
                        id:row.id
                    }
                }).then(res=>{
                    let datalist=[];
                    let objlist=res.data.options.map(e=>{
                        return e
                    })
                    // console.log(objlist);
                    objlist.forEach(e=>{
                        datalist.push(
                            {
                                op1:{
                                    value:e.conditionLeft,
                                    options:[
                                        {
                                            value: '(',
                                            label: '('
                                        },
                                        {
                                            value: '',
                                            label: ' '
                                        }
                                    ]
                                },
                                op2:{
                                    value:e.conditionValue,
                                    options:[]
                                },
                                op3:{
                                    value:e.conditionType,
                                    options:[
                                        {
                                            value:'=',
                                            label:'等于'
                                        },
                                        {
                                            value:'>',
                                            label:'大于'
                                        },
                                        {
                                            value:'>=',
                                            label:'大于等于'
                                        },
                                        {
                                            value:'<',
                                            label:'小于'
                                        },
                                        {
                                            value:'<=',
                                            label:'小于等于'
                                        },
                                        {
                                            value:'!=',
                                            label:'不等于'
                                        },
                                        {
                                            value:'IN',
                                            label:'在之内'
                                        },
                                        {
                                            value:'NOT IN',
                                            label:'不在'
                                        }
                                    ]
                                },
                                op4:{
                                    value:e.conditionOperator
                                },
                                op5:{
                                    value:e.conditionRight,
                                    options:[
                                        {
                                            value:')',
                                            label:')'
                                        },
                                        {
                                            value:'',
                                            label:' '
                                        }
                                    ]
                                },
                                op6:{
                                    value:e.conditionFlag,
                                    options:[
                                        {
                                            value:'OR',
                                            label:'或者'
                                        },
                                        {
                                            value:'AND',
                                            label:'并且'
                                        }
                                    ]
                                }
                            } 
                        )
                    })
                    // console.log(datalist);
                    if(objlist.length>0){
                        this.tjoptions=datalist;
                    }else{
                        this.tjoptions=this.$options.data().tjoptions
                    }
                    this.op2();
                }).catch(error=>{
                    this.$message.error(error.msg)
                });
                callback();
            },


            // 编辑
            editRow: function(row, done, errorDone, optionType) {
                let xn=row.xn;
                let temp = this.mainTable.table.columns.filter(item => item.prop === 'xn');
                let xndata=temp[0].dicData.filter(e=>{
                    return e.label==xn
                })
                if(xndata.length>0){
                    xn=xndata[0].value;
                }else{
                    xn=row.xn
                }
                
                let datalist=this.datalist(row);

                if(row.enable==="启用"){
                    row.enable='1'
                }else{
                    row.enable='0'
                }

                this.$http.post("/limit/saveOrUpdate",
                    {
                        "limitSetVoList":datalist,
                        "limitName": row.limitName,
                        "xn": xn,
                        "application": row.application.toString(),
                        "enable": row.enable,
                        "conditionId": "string",
                        "creator": "wipadmin",
                        "xq": ((row.xq)*1).toString(),
                        "id":row.id
                    },{
                        params:{
                            type:"2"
                        }
                    }
                ).then(res=>{
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
                done();
            },

            // 删除
            deleteRows:function(deleteList){
                let idList=[]
                deleteList=deleteList.map(e=>{
                    idList.push(e.id)
                    return idList
                })
                this.$http.delete('/limit/delete',{
                    params:{idList}
                }).then(res=>{
                    // console.log(res);
                    this.$message.success('删除成功')
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                }).catch(error=>{
                    this.$message.error(error.msg)
                })
            },

            // 增加条件
                tjadd(index){
                    this.tjoptions.splice(index+1,0,
                        {
                        op1:{
                            value:'',
                            options:[
                                {
                                    value: '(',
                                    label: '('
                                },
                                {
                                    value: '',
                                    label: ' '
                                }
                            ]
                        },
                        op2:{
                            value:'',
                            options:[]
                        },
                        op3:{
                            value:'',
                            options:[
                                {
                                    value:'=',
                                    label:'等于'
                                },
                                {
                                    value:'>',
                                    label:'大于'
                                },
                                {
                                    value:'>=',
                                    label:'大于等于'
                                },
                                {
                                    value:'<',
                                    label:'小于'
                                },
                                {
                                    value:'<=',
                                    label:'小于等于'
                                }
                            ]
                        },
                        op4:{
                            value:''
                        },
                        op5:{
                            value:'',
                            options:[
                                {
                                    value:')',
                                    label:')'
                                },
                                {
                                    value:'',
                                    label:' '
                                }
                            ]
                        },
                        op6:{
                            value:'',
                            options:[
                                {
                                    value:'OR',
                                    label:'或者'
                                },
                                {
                                    value:'AND',
                                    label:'并且'
                                }
                            ]
                        }
                    } 
                    )
                    this.op2();
                },

            // 去掉条件
                tjsub(index){
                    if(this.tjoptions.length>1){

                        if (index !== -1) {
                            this.tjoptions.splice(index, 1);
                        }
                    }
                },
            //下拉框
            getSelectDate(url,label,value,prop,params,method){
                method=method||"post";
                params=params||{};
                let column=this.mainTable.table.column;

                this.$http[method](url,params).then(res=>{
                    let arrDate=[];
                    res.data.forEach(element=>{
                        arrDate.push({
                            label:element[label],
                            value:element[value]
                        })
                    });
                    this.$refs.mainTable.setColumnSeting(prop, 'dicData', arrDate)
                })            
            },
            // 排序
            sortBy: function(attr,rev){
                //第二个参数没有传递 默认升序排列
                if(rev ==  undefined){
                    rev = 1;
                }else{
                    rev = (rev) ? 1 : -1;
                }
                
                return function(a,b){
                    a = a[attr];
                    b = b[attr];
                    if(a < b){
                        return rev * -1;
                    }
                    if(a > b){
                        return rev * 1;
                    }
                    return 0;
                }
            },
            // 获取label值data
            
            // 条件2下拉框
            op2(){
                this.$http.post("/conditionLibrary/getConditionInfo").then(res=>{
                    // console.log(res)
                    let arr=[];
                    res.data.forEach(e=>{
                        arr.push({
                            label:e.conditionValue,
                            value:e.comnditionClomn
                        })
                    })
                    // console.log(arr);
                    this.tjoptions.map(e=>{
                        e.op2.options=arr;
                    })
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
            }
        },
        mounted() {
            this.mainTableReload();
            // 学年下拉框
            this.$http.get("/Xn/queryMap").then(res=>{
                let arrDate=[]; 
                res.data.forEach(element=>{
                    arrDate.push({
                        label:element.xnd,
                        value:element.id.toString()
                    })
                });
                arrDate=arrDate.sort(this.sortBy('label',false));
                this.$refs.mainTable.setColumnSeting('xn', 'dicData', arrDate)
            });
            // 应用类型
            // this.getSelectDate("/cpdl/list","dlmc","id","application",null,"get");
            this.$http.get("/cpdl/list").then(res=>{
                let arrDate=[]; 
                res.data.forEach(element=>{
                    arrDate.push({
                        label:element.dlmc,
                        value:element.id.toString()
                    })
                });
                // arrDate=arrDate.sort(this.sortBy('label',false));
                this.$refs.mainTable.setColumnSeting('application', 'dicData', arrDate)
            });
            
            // 条件2下拉框
            this.op2();
        },
    }
</script>

<style lang="scss" scooed>
        
        
    
</style>